<template>
    <div class="disaster-notice-bar" v-if="isShow && noticeText && noticeText.length > 0" :style="`top: ${top}`">
        <span class="notice-icon"></span>
        <div class="notice-marquee">
            <p class="notice-text" ref="marqueeText" :class="{ 'enable-scroll': marqueeEnable }">
                {{ noticeText }}
                <template v-if="marqueeEnable">
                    <i></i>
                    {{ noticeText }}
                    <i></i>
                    {{ noticeText }}
                    <i></i>
                </template>
            </p>
        </div>
        <span class="notice-close" @click="handleClose"></span>
    </div>
</template>

<script>
import * as service from '../../modules/noticeBar';
import storage from 'root/common/util/storage';

export default {
    name: 'noticeBar',
    props: {
        top: {
            default: '0',
        },
        pageId: {
            default: '',
            // 1：首页tab
            // 2：骑士商城tab
            // 3：尊享特权tab
            // 4：美食购物特惠tab
            // 5：我的 tab
            // 6：电商商品详情页
            // 7：视频充值购买页
            // 8：美食购物优惠券列表页
            // 9：美食购物优惠券购买页
        },
    },
    data() {
        return {
            marqueeEnable: false,
            isShow: true,
            noticeAllObj: {},
        };
    },

    mounted() {
        this.getData();
    },

    computed: {
        // 文案通知
        noticeText() {
            if (this.pageId && this.noticeAllObj) {
                return this.noticeAllObj[this.pageId] || '';
            }
            return '';
        },
    },

    methods: {
        // 打开跑马灯
        scrollMarque() {
            let speed = 40; // 速度 -- px每秒
            let $marqueeContent = this.$refs['marqueeText'];
            if ($marqueeContent) {
                let contentWidth = $marqueeContent.getBoundingClientRect().width;
                if (contentWidth <= 0) return false; // 没有内容搞什么动画
                // 内容复制了3份，宽度也要除以3
                contentWidth = contentWidth / 3;
                // 计算一次动画应该要花费多少时间
                let onceTime = (contentWidth / speed) * 1000; //ms
                $marqueeContent.style.animationDuration = onceTime + 'ms';
            }
        },

        // 获取公告信息
        async getData() {
            let noticeAllObj = storage.get(storage.keys.noticeBarContent);
            if (noticeAllObj) {
                this.noticeAllObj = noticeAllObj;
                return;
            }

            let res = await service.getAnnouncement({ index: 'all' });
            if (res.code === 200) {
                this.noticeAllObj = res.data ? res.data : {};
                storage.set(storage.keys.noticeBarContent, this.noticeAllObj, { expires: 60 * 10 });
                if (res.data) {
                    this.openAnimation();
                }
            }
        },

        // 打开跑马灯动画
        openAnimation() {
            // 大于18个字才滚动
            if (this.noticeText.length > 18) {
                this.marqueeEnable = true;
                this.scrollMarque();
            }
        },

        // 关闭
        handleClose() {
            this.isShow = false;
            this.$emit('close');
        },
    },
};
</script>

<style lang="scss" scoped>
.disaster-notice-bar {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 0.8rem;
    z-index: 1002;
    background: rgba($color: #000000, $alpha: 0.8);
    display: flex;
    align-items: center;
    padding: 0 0 0 0.3rem;

    .notice-icon {
        width: 0.32rem;
        height: 0.32rem;
        background: url('../images/disasterNotice/disaster-icon.png') no-repeat center;
        background-size: contain;
    }

    .notice-marquee {
        font-size: 0.28rem;
        color: #fff;
        flex: 1;
        margin-left: 0.2rem;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: clip;
        position: relative;
        overflow: hidden;
        .notice-text {
            display: inline-block;
            white-space: nowrap;
            & > i {
                display: inline-block;
                width: 0.5rem;
            }

            &.enable-scroll {
                animation: kf-marquee-animation 12s infinite linear;
            }
        }
    }

    @keyframes kf-marquee-animation {
        0% {
            transform: translateX(0);
        }
        100% {
            transform: translateX(-33.3%);
        }
    }

    .notice-close {
        width: 0.8rem;
        height: 0.8rem;
        background: url('../images/disasterNotice/disaster-close.png') no-repeat center;
        background-size: 0.3rem 0.3rem;
    }
}
</style>
